import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function ServiceCard({ title, description, icon: Icon, path, image, accentColor = "pink" }) {
  const colors = {
    pink: {
      bg: "bg-gradient-to-r from-purple-500 to-pink-500/10",
      hoverBg: "group-hover:bg-gradient-to-r from-purple-500 to-pink-500",
      text: "text-pink-400",
      border: "hover:border-pink-500/50",
      glow: "group-hover:shadow-[0_0_30px_rgba(248,24,148,0.2)]"
    },
    blue: {
      bg: "bg-gradient-to-r from-blue-500 to-purple-500/10",
      hoverBg: "group-hover:bg-gradient-to-r from-blue-500 to-purple-500",
      text: "text-purple-400",
      border: "hover:border-purple-500/50",
      glow: "group-hover:shadow-[0_0_30px_rgba(30,144,255,0.2)]"
    }
  };

  const color = colors[accentColor];

  return (
    <Link
      to={path}
      data-testid={`service-card-${path.split('/').pop()}`}
      className={`group relative overflow-hidden bg-[#111111] border border-white/10 rounded-2xl transition-all duration-500 hover:-translate-y-2 block ${color.border} ${color.glow}`}
    >
      {/* Image */}
      {image && (
        <div className="relative h-48 overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#111111] via-black/40 to-transparent" />
        </div>
      )}

      {/* Content */}
      <div className="p-6">
        {/* Icon */}
        {Icon && (
          <div className={`w-12 h-12 rounded-xl ${color.bg} flex items-center justify-center mb-4 ${color.hoverBg} transition-colors duration-300`}>
            <Icon className={`w-6 h-6 ${color.text} group-hover:text-white transition-colors duration-300`} />
          </div>
        )}

        {/* Title */}
        <h3 className={`font-heading text-xl font-semibold mb-2 text-white group-hover:${color.text} transition-colors`}>
          {title}
        </h3>

        {/* Description */}
        <p className="text-white/60 text-sm leading-relaxed mb-4">
          {description}
        </p>

        {/* Link */}
        <div className={`flex items-center gap-2 ${color.text} font-medium text-sm`}>
          <span>Learn more</span>
          <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
        </div>
      </div>
    </Link>
  );
}
